<template>
    <div
        v-if="visible"
        ref="user-menu-dropdown"
        class="rounded-md absolute -left-56 top-8 mt-2 z-40 transform origin-center bg-gray-50 text-black shadow-06"
        @click.stop
    >
        <div class="flex flex-col w-64">
            <div class="py-3 px-4 border-b border-gray-300">
                <p class="text-sm font-semibold mb-0 truncate">
                    {{ socialName || name }}
                </p>
                <p class="text-sm font-normal text-gray-700 truncate">
                    {{ email }}
                </p>
            </div>
            <div class="py-1 border-b border-gray-300">
                <ul>
                    <li class="px-1">
                        <a
                            class="flex items-center rounded px-4 py-1 z-50 text-sm font-medium transition hover:bg-gray-200 no-underline"
                            href="javascript:"
                            @click="navigateToProfile"
                            @blur="blurHandler"
                        >
                            <BaseIcon
                                class="mr-1"
                                icon-name="icon-login"
                            >
                                <IconPeople />
                            </BaseIcon>
                            Editar perfil
                        </a>
                    </li>
                </ul>
            </div>

            <div class="py-1">
                <ul>
                    <li class="px-1">
                        <a
                            class="flex items-center rounded px-4 py-1 text-sm font-Wmedium transition hover:bg-gray-200 no-underline"
                            href="javascript:"
                            @click.prevent="logout"
                        >
                            <BaseIcon
                                class="mr-1"
                                icon-name="icon-login"
                            >
                                <IconLogin />
                            </BaseIcon>
                            Sair
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useMixpanel } from '@/composables/useMixpanel';
import { useAuth } from '@/composables/useAuth';
import BaseIcon from '@/icons/BaseIcon';
import IconLogin from '@/icons/IconLogin';
import IconPeople from '@/icons/IconPeople.vue';

const router = useRouter();
const { trackEvent } = useMixpanel();
const { logout } = useAuth();

const emits = defineEmits(['open', 'close']);

const props = defineProps({
    name: {
        type: String,
        default: '',
    },
    socialName: {
        type: String,
        default: '',
    },
    email: {
        type: String,
        default: '',
    },
    userRef: {
        type: String,
        default: '',
    },
    visible: {
        type: Boolean,
        default: false,
    },
});

const navigateToProfile = () => {
    emits('close');
    trackEvent('affiliate-profile-edit-clicked', {
        subscription_ref: props.userRef,
    });
    router.push({ name: 'profile' });
};

const close = () => {
    emits('close');
};

onMounted(() => {
    document.addEventListener('click', close);
});

onUnmounted(() => {
    document.removeEventListener('click', close);
});
</script>
